let ajaxCart = document.querySelector(".ajax-cart-wrap");
let ajaxCartOverlay = document.querySelector(".ajax-cart-overlay");
///////////////////////////Adding product to cart
function addToCart(data, display, loader) {
  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: data,
  })
    .then((response) => {
      if (response.ok) {
        renderProducts(loader, display);
        return response;
      } else {
        return response
          .json()
          .then((text) => cartError(text.description, loader));
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}
////////////// cart error handling
function cartError(error, loader) {
  let errorBox = document.querySelector(".cart-error-notification");
  let errorText = error;
  errorBox.querySelector(".error-notification").textContent = errorText;
  errorBox.classList.add("active");
  loader ? loader.classList.remove("active") : "";
  setTimeout(() => {
    errorBox.classList.remove("active");
  }, 2000);
}
////////////////Quantity selector
document.addEventListener("click", function (e) {
  if (
    e.target.classList.contains("btn-minus") ||
    e.target.closest(".btn-minus")
  ) {
    e.preventDefault();

    let el = e.target.classList.contains("btn-minus")
      ? e.target
      : e.target.closest(".btn-minus");
    updateQuantity(el, false);
  } else if (
    e.target.classList.contains("btn-plus") ||
    e.target.closest(".btn-plus")
  ) {
    e.preventDefault();
    let el = e.target.classList.contains("btn-plus")
      ? e.target
      : e.target.closest(".btn-plus");
    updateQuantity(el, true);
  }
});
function updateQuantity(element, increment) {
  let quantityInput = element.closest("form").querySelector(".quantity");
  let currentValue = Number(quantityInput.value);
  let currentLineItem = Number(element.closest(".cart-item").dataset.id);
  let cushionsItem = element.closest(".cart-item").dataset.quantity;
  let sampleVariant = document.querySelector(".selected-option-value span").innerHTML;
  
  if (increment) {
    quantityInput.value = currentValue + 1;
  } else {
      if(cushionsItem == "true"){
      if(currentValue > 1){
       quantityInput.value = currentValue - 1;  
      }else if(currentValue == 2){
      }
    }else{
      quantityInput.value = currentValue - 1;
    }
  }
  
  let url = element.getAttribute("href");
  url = url.replace(/quantity=(\d+)/, `quantity=${quantityInput.value}`);
  element.setAttribute("href", url);
  updateCartQuantity(url, element);
}
///////////////////////Updating cart item quantity
function updateCartQuantity(url, element) {
  let loader = element
    .closest(".cart-item-wrap")
    .querySelector(".loader-wrapper");
  loader.classList.add("active");
  fetch(url)
    .then((response) => {
      renderProducts(loader, false);
    })
    .catch((error) => console.error(error));
}
////////////////// render products
function renderProducts(loader, display, render) {
  fetch(`${window.location.pathname}?sections=ajax-cart`)
    .then((response) => response.text())
    .then((data) => {
      loader ? loader.classList.remove("active") : "";
      let htmlString = data
        .replaceAll("\\n", "")
        .replaceAll("\\t", "")
        .replaceAll("\\", "");
      var parser = new DOMParser();
      let html = parser.parseFromString(htmlString, "text/html");
      let cartTotal = html.querySelector(".cart-total").textContent;
      let cartItems = html.querySelectorAll(".cart-item");
      let currentItems = document.querySelectorAll(".cart-item");
      let quantity = html.querySelector('input[data-id="cart-count"]').value;
      let emptyText = html.querySelector(".empty-cart");
      if (cartItems.length != currentItems.length || display) {
        document.querySelector(".ajax-cart-body").innerHTML = "";
        emptyText
          ? document.querySelector(".ajax-cart-body").appendChild(emptyText)
          : "";
        cartItems.forEach((el, ind) => {
          document.querySelector(".ajax-cart-body").appendChild(el);
        });
      }
      display ? displayAjaxCartToggle() : "";
      updateCartCount(quantity);
      document.querySelector(".cart-total").textContent = cartTotal;
    });
}

//////////////////////////////Removing item from cart
document.addEventListener("click", function (e) {
  if (
    e.target.classList.contains("clear-prod") ||
    e.target.closest(".clear-prod")
  ) {
    e.preventDefault();
    let el = e.target.classList.contains("clear-prod")
      ? e.target
      : e.target.closest(".clear-prod");
    let minusBtn = el.closest(".cart-item").querySelector(".btn-minus");
    let url = minusBtn.getAttribute("href");
    url = url.replace(/quantity=(\d+)/, `quantity=0`);
    updateCartQuantity(url, minusBtn);
  }
});
//////Updating cart count
function updateCartCount(count) {
  console.log("update cart ");
  let countHolders = document.querySelectorAll(".cart-count");
  countHolders.forEach((el, ind) => {
    el.textContent = count;
  });
}
///////////////////Variant selector
document.addEventListener("click", function (e) {
  if (
    e.target.classList.contains("toggle-variant-wrap") ||
    e.target.closest(".toggle-variant-wrap")
  ) {
    e.preventDefault();
    let el = e.target.classList.contains("toggle-variant-wrap")
      ? e.target
      : e.target.closest(".toggle-variant-wrap");
    let parent = el.closest(".cart-item");
    let variantSelector = parent.querySelector(".variant-selectors-block");
    variantSelector.classList.toggle("active");
  }
});
///////////////////////cart display
document.addEventListener("click", function (e) {
  if (
    e.target.classList.contains("cart-toggle ") ||
    e.target.closest(".cart-toggle ")
  ) {
    e.preventDefault();
    displayAjaxCartToggle();
  } else if (
    e.target.classList != "ajax-cart-wrap" &&
    !e.target.closest(".ajax-cart-wrap")
  ) {
    ajaxCart.classList.remove("active");
  }
});
function displayAjaxCartToggle() {
  ajaxCart.classList.toggle("active");
  ajaxCartOverlay.classList.toggle("active");
}
////////////////ajax cart button
let formData = {
  items: [
    {
      id: 36110175633573,
      quantity: 2,
    },
  ],
};
document.addEventListener("click", function (e) {
  if (
    e.target.classList.contains("ajax-cart") ||
    e.target.closest(".ajax-cart")
  ) {
    e.preventDefault();
    console.log("button clicked");
    let el = e.target.classList.contains("ajax-cart")
      ? e.target
      : e.target.closest(".ajax-cart");
    let form = e.target.closest("form");
    let productId = form.querySelector('input[name="id"]').value;
    let quantity = form.querySelector(".quantity")
      ? form.querySelector(".quantity").value
      : 1;
    let formData = new URLSearchParams(new FormData(form)).toString();
    console.log(formData);
    let displayCart = document
      .querySelector(".ajax-cart-wrap")
      .classList.contains("active")
      ? false
      : true;
    let loader = el.closest("form").querySelector(".loader-wrapper");
    loader ? loader.classList.add("active") : "";
    loader
      ? addToCart(formData, displayCart, loader)
      : addToCart(formData, displayCart, false);
  }
});


